import { AttachmentsModel } from '@/features/attachment/_models/attachment';
import { z } from 'zod';
import { ProjectBaseModel } from './project';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const RelatedMaterialModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  attachments: AttachmentsModel,
  additionalExplanation: z.string().nullish(),
});

export const RelatedMaterialsModel = z.array(RelatedMaterialModel);

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const RelatedMaterialFormSchema = RelatedMaterialModel.pick({
  attachments: true,
}).extend({
  projectId: ProjectBaseModel.shape.id,
  additionalExplanation: z.preprocess(
    (val) => val || null,
    RelatedMaterialModel.shape.additionalExplanation,
  ),
});

export const RelatedMaterialMutationParamsSchema = z.object({
  attachmentIds: z.string().uuid().array().optional(),
  additionalExplanation: RelatedMaterialModel.shape.additionalExplanation,
});
